import { ParallelPagesIllustrationIcon } from '@weblite/icons'
import { SecondaryButton } from '$common/buttons/secondary-button'
import { t } from '$i18n'
import { fullReload } from '$helper/functions/fullReload'
import { ErrorPage } from '../error-page'

const MultiTab = ({ isOpen }: { isOpen: boolean }) => {
  return (
    <ErrorPage
      isOpen={isOpen}
      title={t('multiTab.error')}
      description={t('multiTab.description')}
      actionButtons={
        <SecondaryButton
          text={t('multiTab.refresh')}
          onClick={fullReload}
          fullWidth
        />
      }
      icon={
        <ParallelPagesIllustrationIcon
          sx={{ width: '130px', height: '104px' }}
        />
      }
    />
  )
}

export default MultiTab
